<template>
  <div class="container">
    <div class="text-end p-3">
      <c-primary-button to="/admin/configuraciones/estados/crear">
        Crear estado
      </c-primary-button>
    </div>
    <c-card title="Estados">
      <table class="table table-striped">
        <thead>
          <tr>
            <th>Estado</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="state in states" :key="state.id">
            <td>{{ state.name }}</td>
            <td class="text-nowrap">
              <router-link
                class="btn btn-secondary btn-sm ms-2 d-inline-block"
                :to="`/admin/configuraciones/estados/${state.id}/municipios`"
                title="Municipios"
                ><i class="fa-solid fa-list-ol"></i
              ></router-link>
              <router-link
                class="btn btn-secondary btn-sm ms-2 d-inline-block"
                :to="`/admin/configuraciones/estados/${state.id}/editar`"
                title="Editar"
                ><i class="fa-solid fa-pen"></i
              ></router-link>
              <a
                class="btn btn-secondary btn-sm ms-2 d-inline-block"
                href="javascript:void(0)"
                @click="deleteState(state.id)"
                title="Eliminar"
                ><i class="fa-solid fa-trash-can"></i
              ></a>
            </td>
          </tr>
        </tbody>
      </table>
    </c-card>
  </div>
</template>
<script>
import CCard from "@/components/CCard.vue";
import CPrimaryButton from "@/components/CPrimaryButton.vue";
import { all, remove } from "@/services/states";
import { showNotification } from "@/services/notification";

export default {
  components: {
    CCard,
    CPrimaryButton,
  },
  data() {
    return {
      states: [],
    };
  },
  mounted() {
    this.getStates();
  },
  methods: {
    getStates() {
      all()
        .then((response) => {
          this.states = response.data;
        })
        .catch(() => {
          alert("No pudimos cargar los estados");
        });
    },
    deleteState(id) {
      const removeRecord = confirm("¿Estás seguro de eliminar el registro?");
      if (!removeRecord) {
        return;
      }
      remove(id).then(() => {
        showNotification(204, "success", "El registro fue eliminado.");
        this.getStates();
      });
    },
  },
};
</script>
